import axios from 'axios';
import padStart from 'lodash/padStart';

class OpenHours {
    API_URL = '/k2-kopernik/open-hours/today';

    constructor() {
        this.$headerHours = document.querySelector('.js-opening-hours');
        this.$headerHoursTxt = document.querySelector('.js-opening-hours-txt');
        this.$areas = document.querySelectorAll('.js-area');

        let now = new Date(),
            date = now.getFullYear() + '-' + padStart(now.getMonth() + 1, 2, '0') + '-' + padStart(now.getDate(), 2, '0');

        axios.get(this.API_URL)
            .then(response => {
                if (response && response.status === 200) {
                    let data = response.data[date];

                    if (data) {
                        if (this.$headerHours) {
                            this.initHeaderHours(data);
                        }

                        if (this.$areas && this.$areas.length) {
                            this.initBodyHours(data);
                        }
                    }
                }
            })
            .catch(error => {
                console.warn(error);
            });
    }

    initHeaderHours(data) {
        let cnkData = data['CNK'],
            open = cnkData.open_hour,
            close = cnkData.close_hour,
            template;

        cnkData.closed ? template = document.querySelector('.js-opening-hours-txt-closed').innerHTML : template = document.querySelector('.js-opening-hours-txt-open').innerHTML;

        this.$headerHoursTxt.innerHTML = template;

        if (cnkData.closed || !open || !close) //do not display hours if closed = 1 or 2 (technical monday) or no open/close hours
            return;

        let [open_hour, open_minutes] = open.split(':');
        let [close_hour, close_minutes] = close.split(':');

        this.$headerHours.innerHTML = '';
        this.$headerHours.insertAdjacentHTML('beforeend', `<span class="visuallyhidden">od godziny ${open} do ${close}</span>
            <span aria-hidden="true">
            ${open_hour}<span class="d-none d-md-inline">:${open_minutes}</span>&nbsp;&#8288;&ndash;&#8288;&nbsp;${close_hour}<span class="d-none d-md-inline">:${close_minutes}</span>
        </span>`);
    }

    initBodyHours(data) {
        for (let area in data) {
            if (data.hasOwnProperty(area)) {
                let $area = Array.from(this.$areas).filter(el => el.dataset.area === area)[0];

                if (!$area) {
                    continue;
                }

                let areaData = data[area],
                    $msg = $area.querySelector('.js-area-opening-hours'),
                    now = new Date(),
                    time = padStart(now.getHours(), 2, '0') + ':' + padStart(now.getMinutes(), 2, '0'),
                    template = this.pickTemplate($area, areaData, time);

                $msg.innerHTML = this.renderMessage(areaData, template);
            }
        }
    }

    pickTemplate($area, data, time) {
        let template;

        if (data.closed) {
            template = $area.querySelector('.js-closed').innerHTML;
        } else if (time < padStart(data.open_hour, 5, '0')) {
            template = $area.querySelector('.js-not-open').innerHTML;
        } else if (time >= padStart(data.open_hour, 5, '0') && time < padStart(data.close_hour, 5, '0')) {
            template = $area.querySelector('.js-open').innerHTML;
        } else {
            template = $area.querySelector('.js-already-closed').innerHTML;
        }

        return template;
    }

    renderMessage(data, template) {
        for (let param in data) {
            if (data.hasOwnProperty(param)) {
                template = template.replace(new RegExp(`\\[${param}\\]`, 'g'), data[param]);
            }
        }

        return template;
    }
}

export default OpenHours;
